import React, { useState, useEffect, Dispatch } from 'react';
import {
    IAdditionalInputOptionChoice,
    onWorkflowTaskReply,
} from '../../../../redux/project/sliceProjectWorkflow';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Message from './Message';
import { mdiInformation } from '@mdi/js';
import { useDispatch } from 'react-redux';
import { IAdditionalInfoResultButtonEnum } from './AdditionalInputFooterActions';

export default ({ values }: { values: IAdditionalInputOptionChoice[] }) => {
    const dispatch: Dispatch<unknown> = useDispatch();
    const { t } = useTranslation('translations', { keyPrefix: 'workflowAdditionalInput' });
    const { replicaId } = useParams();
    const timer = Number(values.find(item => item.alias === 'timeout')?.value ?? 0);
    const [time, setTime] = useState(timer);
    const [intervalId, setIntervalId] = useState(null);

    useEffect(() => {
        const id = setInterval(() => {
            setTime(prevTime => prevTime - 1);
        }, 1000);
        setIntervalId(id);
        return () => clearInterval(id);
    }, []);

    useEffect(() => {
        if (time <= 0) {
            clearInterval(intervalId);
        }
        if (time === 0) {
            dispatch(
                onWorkflowTaskReply({
                    dialogResultButton: IAdditionalInfoResultButtonEnum.Cancel,
                    additionalInputState: [],
                    replicaId: replicaId,
                }),
            );
        }
    }, [time]);

    const formatTime = time => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    return (
        <Message
            text={t('digiSealSignContent', { timeLeft: formatTime(time) })}
            icon={mdiInformation}
        />
    );
};
